import React from 'react';

const Icon153OrientationDisplaySingleArmChairLeft = props => (
  <svg
    focusable="false"
    viewBox="0 0 800 800"
    aria-hidden="true"
    role="presentation"
    {...props}
  >
    <path
      d="M312.55,317.75h216.75v202.3c0,7.98-6.47,14.45-14.45,14.45h-187.85c-7.98,0-14.45-6.47-14.45-14.45v-202.3h0Z"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <path
      d="M279.88,265.5h32.67v259.82c0,5.07-4.11,9.18-9.18,9.18h-23.49c-5.07,0-9.18-4.11-9.18-9.18v-250.64c0-5.07,4.11-9.18,9.18-9.18Z"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <rect
      x="312.55"
      y="265.5"
      width="216.75"
      height="52.25"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
  </svg>
);

export default Icon153OrientationDisplaySingleArmChairLeft;
